import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
// import AppNavbar from "../../Navbar/AppNavbar";

import Footer from "../../Navbar/Footer";
import saveImg from "../../../assets/images/searchContact/saveImg.svg";
import "../../../assets/css/search.scss";
import { useDispatch, useSelector } from "react-redux";
import { loadMyListData, loadSavedSearches, updateSavedSearchData } from "../../redux/action";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import EditMyListModal from "./EditMyListModal";
import DeleteMyListModal from "./DeleteMyListModal";
import AppLayout from "../../Navbar/AppLayout";

const MyList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const role = signInDetails[0]?.role;
    const { myListData } = useSelector((state) => state.data);

    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedIndexToDelete, setSelectedIndexToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedSearch, setSelectedSearch] = useState(null);

    const handleMenuToggle = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    const handleOpenEdit = (item) => {
        setSelectedSearch(item);
        setShowEditModal(true);
        setOpenMenuIndex(null);
    };

    const handleDeleteClick = (item) => {
        setSelectedSearch(item);
        setShowDeleteModal(true);
    };

    const fetchMyListData = () => {
        dispatch(loadMyListData(signInID, sbnID, setLoading));
    }

    useEffect(() => {
        fetchMyListData();
    }, [signInID, sbnID]);


    const handleView = (item) => {
        navigate(`/viewed-contacts`, { state: { listName: item.list_name } });
    };

    return (
        <div className="page-layout">
            {/* <AppNavbar /> */}
            <AppLayout>
            <div className="page-content">
                <div className="saved-search-container">
                    <div className="saved-search-header-container">
                        <div className="saved-search-header-div">
                            <p>My List</p>
                            <div className="saved-search-img-div">
                                <h5 className="m-0">List Names</h5>
                                <i class="fa-solid fa-list"></i>
                            </div>
                        </div>
                    </div>
                    <div className="saved-searches-body">
                        <Row className="m-0 saved-searches-card-row">
                            {myListData && myListData.length > 0 ? (
                                myListData.map((item, index) => (
                                    <Col md={3} sm={6} xs={12} className="saved-searches-card-col mb-3" key={index}>
                                        <Card className="shadow-sm h-100 position-relative">
                                            <Card.Body>
                                                <div className="d-flex justify-content-between align-items-start mb-2 position-relative">
                                                    <Card.Title className="mb-0 fs-6 fw-semibold">  {item.list_name}&nbsp;({item.viewed_count ?? 0})</Card.Title>
                                                    <i
                                                        className="fa-solid fa-ellipsis-vertical"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => handleMenuToggle(index)}
                                                    ></i>

                                                    {openMenuIndex === index && (
                                                        <div className="dropdown-card-options">
                                                            <div className="dropdown-item" onClick={() => handleView(item)}>
                                                                <p><i className="fa-solid fa-eye"></i><span>View</span></p>
                                                            </div>
                                                            <div className="dropdown-item" onClick={() => handleOpenEdit(item)}>
                                                                <p><i className="fa-solid fa-pen-to-square"></i><span>Edit</span></p>
                                                            </div>
                                                            <div className="dropdown-item" onClick={() => handleDeleteClick(item)}>
                                                                <p><i className="fa-solid fa-trash"></i><span>Delete</span></p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Card.Text className="card-date-time">
                                                    <p>Time <span>: {new Date(item.list_created_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span></p>
                                                    <p>Date <span>: {new Date(item.list_created_datetime).toLocaleDateString()}</span></p>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <p>No saved searches available</p>
                            )}
                        </Row>
                    </div>
                </div>

                {/* Modal Component (UI only) */}
                <EditMyListModal
                    show={showEditModal}
                    onHide={() => setShowEditModal(false)}
                    updateSavedSearchData={updateSavedSearchData}
                    selectedSearch={selectedSearch}
                    fetchMyListData={fetchMyListData}
                    role={role}
                    signInID={signInID}
                    sbnID={sbnID}
                />
                <DeleteMyListModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    selectedSearch={selectedSearch}
                    fetchMyListData={fetchMyListData}
                    sbnID={sbnID}
                    signInID={signInID}
                />
            </div>
            </AppLayout>
            <Footer />
        </div>
    );
};

export default MyList;